import { clsx } from 'clsx';

import type { PropsWithChildren, ReactNode } from 'react';

import styles from './Fieldset.module.css';

export interface FieldsetProps {
  /** The description to render. */
  description?: ReactNode;
  /** The id of the description element. Used together with the description property. */
  descriptionId?: string;
  /** true if the form fields should render inline; otherwise, false. The default is false. */
  inline?: boolean;
  /** The legend to render. */
  legend: string;
}

/** Represents a component to show a collection of form field elements. */
export const Fieldset = ({
  inline,
  legend,
  description,
  descriptionId,
  children,
}: PropsWithChildren<FieldsetProps>) => (
  <fieldset
    className={clsx(styles['fieldset'], {
      [styles['fieldset--inline']]: inline,
    })}
  >
    <div>
      <legend className={styles['fieldset__legend']}>{legend}</legend>
      {description && (
        <p className={styles['fieldset__description']} id={descriptionId}>
          {description}
        </p>
      )}
    </div>
    {children}
  </fieldset>
);
